export const GET_LIST_DANHSACHDONDATHANG = "GET_LIST_DANHSACHDONDATHANG";
export const GET_LIST_DANHSACHDONDATHANG_SUCCESS = "GET_LIST_DANHSACHDONDATHANG_SUCCESS";
export const GET_LIST_DANHSACHDONDATHANG_FAILURE = "GET_LIST_DANHSACHDONDATHANG_FAILURE";

export const UPDATE_SEARCHTDATA_DANHSACHDONDATHANG = "UPDATE_SEARCHTDATA_DANHSACHDONDATHANG";
export const UPDATE_DANHSACHDONDATHANG = "UPDATE_DANHSACHDONDATHANG";
export const UPDATE_SEARCHTDATA_INNHANHDANHSACHDONDATHANG = "UPDATE_SEARCHTDATA_INNHANHDANHSACHDONDATHANG";
